import { DecimalPipe } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
  OnyxDataWidgetComponent,
  OnyxDistancePipe,
  OnyxIconComponent,
  OnyxTooltipDirective,
} from '@onyx/angular';
import { AuthStore } from '../../../../../../../auth/common/stores/auth.store';
import { NumberDecorationPipe } from '../../../../../../../common/pipes/number-decoration.pipe';
import { OrderHelper } from '../../../../../common/helpers/order.helper';
import type { Order } from '../../../../../common/interfaces/order';

@Component({
  selector: 'app-order-modal-plan-kilometers',
  imports: [
    OnyxDataWidgetComponent,
    TranslatePipe,
    NumberDecorationPipe,
    DecimalPipe,
    OnyxTooltipDirective,
    OnyxIconComponent,
    OnyxDistancePipe,
  ],
  templateUrl: './order-modal-plan-kilometers.component.html',
  styleUrl: './order-modal-plan-kilometers.component.scss',
})
export class OrderModalPlanKilometersComponent {
  private readonly authStore = inject(AuthStore);

  public readonly order = input.required<Order>();

  protected readonly I18N = 'orders.orderModal.plan';

  protected totalDistance = computed(() =>
    OrderHelper.getTotalDistance(this.order()),
  );
  protected distance = computed(() => OrderHelper.getDistance(this.order()));
  protected emptyDistance = computed(() =>
    OrderHelper.getEmptyDistance(this.order()),
  );
  protected remainingDistance = computed(() =>
    OrderHelper.getRemainingDistance(this.order()),
  );
  protected isEmptyDistanceError = computed(() => {
    const emptyDistance = this.emptyDistance()?.value;
    if (
      !emptyDistance ||
      !OrderHelper.getManualProposal(this.order())?.result
    ) {
      return false;
    }

    return OrderHelper.hasEmptyDistanceError(
      emptyDistance,
      this.distance(),
      this.authStore,
    );
  });
}
